var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { CircularProgress, Stack } from "@mui/material";
import { useAuth } from "../hooks/useAuth";
import { UsuarioInexistente } from "../pages/UsuarioInexistente";
import { AppRoutes } from "./routes";
export var RouterManager = function () {
    var _a = useAuth(), infoDetran = _a.infoDetran, loading = _a.loading;
    var routes = useMemo(function () {
        return Object.keys(AppRoutes).map(function (path) {
            var RouteComponent = AppRoutes[path];
            return _jsx(Route, { path: path, element: _jsx(RouteComponent, {}) }, path);
        });
    }, []);
    if (loading) {
        _jsx(Stack, __assign({ alignItems: "center", marginTop: "4rem" }, { children: _jsx(CircularProgress, {}) }));
    }
    if (!(infoDetran === null || infoDetran === void 0 ? void 0 : infoDetran.cpf)) {
        return _jsx(UsuarioInexistente, {});
    }
    return _jsx(Routes, { children: routes });
};
